import React from 'react';
import SbEditable from 'storyblok-react';

import createMemo from '../../utils/storyblokRelationsMemo';

const storyMemo = createMemo();

/**
 * Allows rendering Storyblok stories as nestable types.
 * @param {Object} props
 * @param {string} props.story
 */
const Story =
  (ComponentList) =>
  ({ story: storyRel }) => {
    const story = storyMemo(storyRel);

    const { content } = story ?? {};

    return content ? (
      <SbEditable key={'_' + content._uid} content={content}>
        {React.createElement(ComponentList[content.component], {
          key: content._uid,
          ...content,
        })}
      </SbEditable>
    ) : (
      <h1>Missing content in Story</h1>
    );
  };

export default Story;
